import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import '../../../assets/scss/resumopf.scss';
import configBase from '../../../configBase';
import axios from 'axios';
import InputMask from 'react-input-mask';
import DateFnsUtils from '@date-io/date-fns';
import ptBRLocale from "date-fns/locale/pt-BR";
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import {DropzoneDialog} from 'material-ui-dropzone'

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
//import ClearIcon from '@material-ui/icons/Clear';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

import {
  ScrollableTabsButtonAuto
} from './components';



class ResumoSimples extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      titlePage: '',
      detailsData: 'loading',
      detailsDataLoadingMsg: 'VALIDANDO A PROPOSTA...',

      stateList: [],
      addressTypeList: [],
      cityList: [],
      districtList: [],

      modalConfirmOpen: false,
      modalConfirmQuestionContent: '',
      modalConfirmActionType: '',
      modalConfirmButton: '',
      modalConfirmButtonLoading: false,
      modalConfirmQuestion: false,
      fieldCancel: 'null',

      currentTimeServer: null,
      listYear: [],
      errorRequest: false,
      msgErrorRequest: '',
      snackbarSuccess: false,
      msgSnackbarSuccess: '',

      disabledInput: true,
      disabledInputValuePlan: true,
      disabledInputHolder: true,

      disabledLoadingAddressType: false,
      disabledLoadingAddressNumber: false,
      disabledLoadingAddress: false,
      disabledLoadingAddressComplement: false,
      disabledLoadingState: false,
      disabledLoadingCity: false,
      disabledLoadingDistrict: false,

      fMCity: '',
      fMDistrict: '',

      showActionCancel: false,
      showActionCancelField: false,

      dropzoneDialog: false,
      typeFile: '',

      fullScreenModal: false,
      showButtons: false,
      showButtonWhatsapp: false,
      goPageList: false,
      disableButtons: false,
    };

    this.configStage = {
      2: "Dados do Responsável Financeiro",
      3: "Anexos",
      4: "Endereço",
      5: "Cadastro dos Beneficiários",
      6: "Termos e Pagamento",
    };

  }


  componentDidMount() {
    this.beforeDetails();
    this.fullScreenModalFn();
  }

  fullScreenModalFn() {
    let width = document.getElementsByTagName('body')[0].offsetWidth;
    let state = this.state;

    if (width > 960)
      state.fullScreenModal = false;
    else
      state.fullScreenModal = true;

    this.setState(state);
  }

  beforeDetails() {
    let state = this.state;
    let fm = this.props.history.location.search.replace('?fm=', '');

    if (fm && fm.length > 0) {
      let url = configBase.api + 'FinancialManagers/count?where={"id":"'+fm+'"}&access_token='+localStorage.getItem('planos_t');

      axios.get(url)
      .then((response) => {
        state.detailsDataLoadingMsg = 'BUSCANDO LISTA DE TIPOS DE LOGRADOUROS...';
        this.setState(state);

        // Caso encontre a proposta
        if (response.data.count > 0) {




          axios.get(configBase.api + 'APIS4s/tipoLogradouro?access_token='+localStorage.getItem('planos_t'))
          .then((response2) => {
            let state = this.state;
            state.detailsDataLoadingMsg = 'BUSCANDO LISTA DE ESTADOS...';
            state.addressTypeList = response2.data; // Tipo logradouro
            this.setState(state);

            // Pega a lista de estados
            axios.get(configBase.api + 'APIS4s/UFs?access_token='+localStorage.getItem('planos_t'))
            .then((response3) => {
              // Estados
              state.stateList = response3.data;
              state.detailsDataLoadingMsg = 'VERIFICANDO DATA E HORA ATUAL...';
              this.setState(state);




              // Pega a data atual do servidor
              axios.post(configBase.api + 'Sales/currentTime?access_token='+localStorage.getItem('planos_t'))
              .then((response4) => {
                // Hora atual do servidor
                state.currentTimeServer = response4.data;
                state.detailsDataLoadingMsg = 'BUSCANDO DADOS DA PROPOSTA...';

                this.getDetails(fm);
                this.setState(state);

              })
              .catch(function () {
                this.setError('Problema encontrado ao verificar a data e hora atual', 'error');
              }.bind(this));





            })
            .catch(function () {
              this.setError('Problema encontrado ao buscar a lista dos estados', 'error');
            }.bind(this));
          })
          .catch(function () {
            this.setError('Problema encontrado ao buscar a lista dos tipos de logradouro', 'error');
          }.bind(this));


        }
        else {
          let state = this.state;
          state.detailsData = 'zero';
          //state.showButtons = false;
          this.setState(state);
        }
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar dados da proposta', 'error');
      }.bind(this));
    }
    else {
      state.titlePage = '';
      this.setError('A proposta é obrigatória', 'error');
    }

    this.setState(state);
  }

  getDetails(fm) {
    let dataPost = {
      financialManagerId: fm
    };

    let url = configBase.api + 'FinancialManagers/getProposalDetailsFm?access_token='+localStorage.getItem('planos_t');

    axios.post(url, dataPost)
    .then((response) => {
      console.log(response.data);
      let userType = localStorage.getItem('planos_y');
      let state = this.state;
      state.titlePage = ' - '+response.data.financialManager.proposalNumber;
      state.detailsData = response.data;
      state.showButtons = true;

      if (userType === 'SALESMAN' || userType === 'BROKER') {
        // Permite edição de campos do resumo da proposta
        state.disabledInput = false;
        state.disabledInputValuePlan = true;
      }

      let created = new Date(response.data.financialManager.created);

      // Lista com os anos para exibir no select
      state.listYear = [];
      state.listYear.push(created.getFullYear() - 2);
      state.listYear.push(created.getFullYear() - 1);
      state.listYear.push(created.getFullYear());
      state.listYear.push(created.getFullYear() + 1);
      state.listYear.push(created.getFullYear() + 2);

      // Verifica edição de campos do titular
      if (response.data.financialManager.cpf === response.data.holder.cpf)
        state.disabledInputHolder = true;
      else
        state.disabledInputHolder = false;

      if (response.data.financialManager.tempPassword === true) {
        state.showButtonWhatsapp = true;
      }

      if (response.data.financialManager.delete === true) {
        state.showButtons = false;
        state.disabledInput = true;
      }

      this.setState(state);

      this.getCity();
    })
    .catch(function () {
      let state = this.state;
      state.detailsData = 'error';
      //state.showButtons = false;
      this.setState(state);
    }.bind(this));
  }

  getCity() {
    let chosenState = this.state.detailsData.financialManager.state;

    if (chosenState !== undefined && chosenState !== null && chosenState !== 0 && chosenState !== '0') {
      let dataPost = {
        'idUF': parseInt(this.state.detailsData.financialManager.state)
      };

      let state = this.state;
      state.disabledLoadingCity = true;
      state.disabledLoadingDistrict = true;
      this.setState(state);
  
      // Pega a lista de cidades
      axios.post(configBase.api + 'APIS4s/Municipios?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then((result) => {
        let state = this.state;
        state.cityList = result.data;
        state.fMCity = this.state.detailsData.financialManager.city;
        state.disabledLoadingCity = false;
        state.disabledLoadingDistrict = false;
        this.setState(state);
  
        // Pega os bairros
        this.getDistrict();
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar lista de municípios pelo estado', this.state.detailsData);
      }.bind(this));
    }
  }

  getDistrict() {
    let dataPost = {
      'idCity': parseInt(this.state.detailsData.financialManager.city)
    };
    let state = this.state;
    state.disabledLoadingDistrict = true;
    this.setState(state);

    // Pega a lista oa bairros
    axios.post(configBase.api + 'APIS4s/Bairros?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      state.fMDistrict = this.state.detailsData.financialManager.district;
      state.disabledLoadingDistrict = false;
      this.setState(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de bairros pela cidade', this.state.detailsData);
    }.bind(this));
  }

  updateFieldFM(e) {
    let state = this.state;

    if (e.target.name === 'city') {
      state.detailsData.financialManager[e.target.name] = e.target.value;
      state.fMCity = e.target.value;
      this.setState(state);
      this.getDistrict();
    }
    else if (e.target.name === 'district') {
      state.detailsData.financialManager[e.target.name] = e.target.value;
      state.fMDistrict = e.target.value;
      this.setState(state);
    }
    else if (e.target.name === 'state') {
      state.detailsData.financialManager[e.target.name] = e.target.value;
      this.setState(state);
      this.getCity();
    }
    else {
      state.detailsData.financialManager[e.target.name] = e.target.value;
      this.setState(state);
    }
  }

  updateDBFinancialManager(field) {
    let dataSubmit = {};
    let commonFields = [
      'firstName', 'dateOfBirth', 'gender',
      'maritalStatus', 'motherName', 'susNumber'
    ];

    // Retira a máscara da data do cartão
    if (field === 'cardValidity')
      dataSubmit[field] = this.state.detailsData.financialManager[field].replace('/', '');
    else
      dataSubmit[field] = this.state.detailsData.financialManager[field];

    axios.post(configBase.api + 'FinancialManagers/upsertWithWhere?where={"id":"'+ this.state.detailsData.financialManager.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {
      // Verifica se o Responsável Financeiro e o titular são o mesmo
      if (this.state.detailsData.financialManager.cpf === this.state.detailsData.holder.cpf) {
        if (commonFields.indexOf(field) >= 0) {
          this.updateFieldHolder(field, null, this.state.detailsData.financialManager[field]);
          this.updateDBHolder(field);
        }
      }
    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do responsável financeiro', this.state.detailsData);
    }.bind(this));
  }

  updateFieldDate(model, field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      day = value.getDate();
      month = value.getMonth() + 1;
      year = value.getFullYear();;

      if (day < 10)
        day = '0'+ day;
      if (month < 10)
        month = '0'+ month;

      state.detailsData[model][field] = year+'-'+month+'-'+day;

      // Salva no banco
      if (model === 'holder')
        this.updateDBHolder(field);
      else
        this.updateDBFinancialManager(field);

      this.setState(state);
    }
  }

  updateFieldHolder(id, event, value=null) {
    let state = this.state;

    if (value === null)
      state.detailsData.holder[id] = event.target.value.replace('R$ ', '');
    else
      state.detailsData.holder[id] = value.replace('R$ ', '');

    this.setState(state);
  }

  updateDBHolder(field) {
    let dataSubmit = {};

    if (field === 'valuePlan') {
      let value = this.state.detailsData.holder[field].split('.');

      if (value[1]) {
        if (value[1].length === 1) {
          value = value[0] + ',' + value[1] + '0';
        }
        else if (value[1].length === 0) {
          value = value[0] + ',00';
        }
      }
      else {
        value = value[0] + ',00';
      }

      dataSubmit[field] = value;
    }
    else
      dataSubmit[field] = this.state.detailsData.holder[field];

    axios.post(configBase.api + 'Dependents/upsertWithWhere?where={"id":"'+ this.state.detailsData.holder.id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {

    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do titular', this.state.detailsData);
    }.bind(this));
  }

  updateCurrencydHolder(event, value) {
    let state = this.state;
    state.detailsData.holder[event.target.name] = value;
    this.setState(state);
  }

  updateFieldDependent(id, index, event) {
    let state = this.state;
    state.detailsData.dependents[index][id] = event.target.value;
    this.setState(state);
  }

  updateDBDependent(field, index) {
    let dataSubmit = {};

    if (field === 'valuePlan') {
      let value = this.state.detailsData.dependents[index][field].split('.');

      if (value[1]) {
        if (value[1].length === 1) {
          value = value[0] + ',' + value[1] + '0';
        }
        else if (value[1].length === 0) {
          value = value[0] + ',00';
        }
      }
      else {
        value = value[0] + ',00';
      }

      dataSubmit[field] = value;
    }
    else
      dataSubmit[field] = this.state.detailsData.dependents[index][field];

    axios.post(configBase.api + 'Dependents/upsertWithWhere?where={"id":"'+ this.state.detailsData.dependents[index].id +'"}&access_token='+localStorage.getItem('planos_t'), dataSubmit)
    .then(() => {

    })
    .catch(function () {
      this.setError('Problema encontrado ao salvar dados do dependente', this.state.detailsData);
    }.bind(this));
  }

  updatedDependentsDate(index, field, value) {
    value = new Date(value);
    let state = this.state;
    let day = null;
    let month = null;
    let year = null;

    // Se for uma data correta
    if (isNaN(value.getDate()) === false) {
      day = value.getDate();
      month = value.getMonth() + 1;
      year = value.getFullYear();;

      if (day < 10)
        day = '0'+ day;
      if (month < 10)
        month = '0'+ month;

      state.detailsData.dependents[index][field] = year+'-'+month+'-'+day;

      this.updateDBDependent(field, index);

      this.setState(state);
    }
  }

  updateCurrencydDependents(index, event, value) {
    let state = this.state;
    state.detailsData.dependents[index][event.target.name] = value;
    this.setState(state);
  }

  getAddress() {
    let valueCep = this.state.detailsData.financialManager.cep;
    let state = this.state;
    state.disabledLoadingAddressType = true;
    state.disabledLoadingAddress = true;
    state.disabledLoadingAddressNumber = true;
    state.disabledLoadingAddressComplement = true;
    state.disabledLoadingState = true;
    state.disabledLoadingCity = true;
    state.disabledLoadingDistrict = true;
    this.setState(state);

    if (valueCep.length >= 8) {
      let dataPost = {
        'cep': valueCep
      };

      axios.post(configBase.api + 'APIS4s/Endereco?access_token='+localStorage.getItem('planos_t'), dataPost)
      .then((result) => {
        if (result.data !== null) {
          // Atualiza a lista de cidades e de bairros
          let state = this.state;
          state.cityList = [];
          state.districtList = [];
          state.detailsData.financialManager.addressType = result.data.IdTipoLogradouro;
          state.detailsData.financialManager.address = result.data.Logradouro;
          state.detailsData.financialManager.state = result.data.IdUf;
          this.setState(state);

          // Salva o Responsável Financeiro no banco
          this.updateDBFinancialManager('addressType');
          this.updateDBFinancialManager('address');
          this.updateDBFinancialManager('state');
          this.updateDBFinancialManager('cep');

          this.getCityEdit(function (stateCity) {
            stateCity.detailsData.financialManager.addressType = result.data.IdTipoLogradouro;

            stateCity.detailsData.financialManager.city = result.data.IdMunicipio;
            stateCity.fMCity = result.data.IdMunicipio;
            this.setState(stateCity);

            this.getDistrictEdit(function (stateDistrict) {
              // Salva o Responsável Financeiro no banco
              this.updateDBFinancialManager('city');

              stateDistrict.detailsData.financialManager.district = result.data.IdBairro;
              stateDistrict.fMDistrict = result.data.IdBairro;

              // Salva o Responsável Financeiro no banco
              this.updateDBFinancialManager('district');

              stateDistrict.disabledLoadingAddressType = false;
              stateDistrict.disabledLoadingAddress = false;
              stateDistrict.disabledLoadingAddressNumber = false;
              stateDistrict.disabledLoadingAddressComplement = false;
              stateDistrict.disabledLoadingState = false;
              stateDistrict.disabledLoadingCity = false;
              stateDistrict.disabledLoadingDistrict = false;
              this.setState(stateDistrict);

              document.getElementById('fm_addressNumber').focus();
            }.bind(this));
          }.bind(this));
        }
        else {
          let state = this.state;
          state.disabledLoadingAddressType = false;
          state.disabledLoadingAddress = false;
          state.disabledLoadingAddressNumber = false;
          state.disabledLoadingAddressComplement = false;
          state.disabledLoadingState = false;
          state.disabledLoadingCity = false;
          state.disabledLoadingDistrict = false;
          this.setError('CEP inválido', this.state.detailsData);
        }
      })
      .catch(function () {
        this.setError('Problema encontrado ao buscar endereço pelo CEP', this.state.detailsData);
      }.bind(this));
    }
    else {
      let state = this.state;
      state.disabledLoadingAddressType = false;
      state.disabledLoadingAddress = false;
      state.disabledLoadingAddressNumber = false;
      state.disabledLoadingAddressComplement = false;
      state.disabledLoadingState = false;
      state.disabledLoadingCity = false;
      state.disabledLoadingDistrict = false;
      this.setState(state);
    }
  }

  getCityEdit(cb=null) {
    let chosenState = 0;
    chosenState = this.state.detailsData.financialManager.state;

    let dataPost = {
      'idUF': parseInt(chosenState)
    };

    // Pega a lista de cidades
    axios.post(configBase.api + 'APIS4s/Municipios?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      state.disabledLoadingCity = false;

      this.setState(state);

      if (cb !== null)
        cb(state);
    })
    .catch(function () {
      this.setError('Problema encontrado ao buscar lista de municípios pelo estado', this.state.detailsData);
    }.bind(this));
  }

  getDistrictEdit(cb=null) {
    let chosenCity = 0;
    chosenCity = this.state.detailsData.financialManager.city;
    let dataPost = {
      idCity: parseInt(chosenCity)
    };

    // Pega a lista oa bairros
    axios.post(configBase.api + 'APIS4s/Bairros?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);

      if (cb !== null)
        cb(state);
    })
    .catch(function (error) {
      this.setError('Problema encontrado ao buscar lista de bairros pela cidade', this.state.detailsData);
    }.bind(this));
  }

  setError(msg, contentTable='error') {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    state.detailsData = contentTable;
    //state.showButtons = false;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  openWindow(image, title) {
    let url = `${process.env.PUBLIC_URL}/visualizardoc?doc=${image}`;

    window.open(
      url,
      title,
      "location,status,scrollbars,resizable,width=800, height=800"
    );
  }

  dropzoneDialogOpen(typeFile=null) {
    let state = this.state;
    state.dropzoneDialog = true;

    if (typeFile !== null)
      state.typeFile = typeFile;

    this.setState(state);
  }

  dropzoneDialogClose() {
    let state = this.state;
    state.dropzoneDialog = false;
    this.setState(state);
  }

  fileToBase64(files) {
    /*
    * @type pode ser: "cpf", "rg", "rg2", "resid", "credtFrontal", "physicalContract", "adtive", "others", "declarationPortability"
    */

    let reader = new FileReader();
    let file = files[0];

    reader.onloadend = function() {
      let dataSubmit = {
        id: this.state.detailsData.financialManager.id,
        imagesDocId: this.state.detailsData.imagesDoc.id,
        imagesDocs: {
          cpf: '',
          rg: '',
          rg2: '',
          address: '',
          credtFrontal: '',
          physicalContract: '',
          adtive: '',
          others: '',
          declarationPortability: '',
        }
      };

      if (this.state.typeFile === 'resid')
        dataSubmit.imagesDocs.address = reader.result;
      else
        dataSubmit.imagesDocs[this.state.typeFile] = reader.result;

      axios.post(configBase.api + 'ImagesDocs/saveDocsFinancialManager?access_token='+localStorage.getItem('planos_t'), dataSubmit)
      .then((response) => {
        let state = this.state;
        state.detailsData.imagesDoc = response.data.images;

        let ext = state.detailsData.imagesDoc[this.state.typeFile].substr(
          state.detailsData.imagesDoc[this.state.typeFile].length - 3,
          state.detailsData.imagesDoc[this.state.typeFile].length
        ).toLowerCase();

        state.detailsData.imagesDoc[this.state.typeFile] = state.detailsData.imagesDoc[this.state.typeFile]+'?v='+new Date().getTime()+ext;
        this.setState(state);

        this.dropzoneDialogClose();

        this.forceUpdate();
      })
      .catch(function () {
        this.setError('Problema encontrado ao salvar documento', this.state.detailsData);
      }.bind(this));

    }.bind(this);
    reader.readAsDataURL(file);
  }

  handleConfirmOpen(question, action, txtButton) {
    /*
    * @action pode ser: "email", "delete"
    */

    let state = this.state;
    state.modalConfirmOpen = true;
    state.modalConfirmQuestionContent = question;
    state.modalConfirmQuestion = true;
    state.modalConfirmActionType = action;
    state.modalConfirmButton = txtButton;

    this.fullScreenModalFn();
  }

  handleConfirmClose () {
    let state = this.state;
    state.modalConfirmOpen = false;
    this.setState(state);
  }

  actionsModal() {
    let state = this.state;
    state.modalConfirmQuestion = false;
    this.setState(state);
  }

  updateFieldCancel(e) {
    let state = this.state;
    state.fieldCancel = e.target.value;
    this.setState(state);
  }

  snackbarSuccessOpen(msg) {
    let state = this.state;
    state.snackbarSuccess = true;
    state.msgSnackbarSuccess = msg;
    this.setState(state);
  }

  snackbarSuccessClose() {
    let state = this.state;
    state.snackbarSuccess = false;
    state.msgSnackbarSuccess = '';
    this.setState(state);

    if (this.state.goPageList === true)
      this.goList();
  }

  sendEmail() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let data = {
      id: this.state.detailsData.financialManager.id
    };

    axios.post(configBase.api + 'Sales/SendEmailProposalCreate?access_token='+localStorage.getItem('planos_t'), data)
    .then((result) => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;

      if (result.data.error !== undefined && result.data.error === true) {
        this.handleConfirmClose();
        this.setError('Houve um problema no envio de email ao responsável financeiro', this.state.detailsData);
      }
      else {
        this.handleConfirmClose();
        this.snackbarSuccessOpen('E-mail reenviado com sucesso');
        this.getDetails(this.state.detailsData.financialManager.id.toString());
      }
    })
    .catch(() => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.handleConfirmClose();
      this.setError('Houve um problema no envio de email ao responsável financeiro', this.state.detailsData);
    });
  }

  deleteProposal() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    let dataPost = {
      financialManagerId: this.state.detailsData.financialManager.id,
      userId: localStorage.getItem('planos_u'),
    };

    axios.post(configBase.api + 'FinancialManagers/excluir?access_token='+localStorage.getItem('planos_t'), dataPost)
    .then(() => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      state.goPageList = true;
      state.disableButtons = true;
      state.detailsData = 'zero';

      this.handleConfirmClose();
      this.snackbarSuccessOpen('Proposta excluída com sucesso.');
    })
    .catch(() => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.handleConfirmClose();
      this.setError('Houve um problema ao excluir proposta.', this.state.detailsData);
    });
  }

  goList() {
    this.props.history.push(`${process.env.PUBLIC_URL}/novaspf`);
  }

  detalhes() {
    return (
      <div id="detalhes">
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Estágio da Proposta
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Alert severity="info">{this.state.detailsData.financialManager.stageForm + ". "+this.configStage[this.state.detailsData.financialManager.stageForm]}</Alert>
              </Grid>
            </Grid>
          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Plano Contratado
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
            {
              this.state.detailsData.financialManager.plansId ? ('') : (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Nome Fantasia"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.planCompany.fantasyName}
                />
              </Grid>
              )
            }
            {
              this.state.detailsData.financialManager.plansId ? ('') : (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Razão Social"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.planCompany.corporateName}
                />
              </Grid>
              )
            }

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Plano"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.plan.name}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  disabled
                  fullWidth
                  label="R$ por Mês"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.responsibility}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  disabled
                  fullWidth
                  label="Adesão Dia"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.dateSignatureContract}
                />
              </Grid>

              {
                this.state.detailsData.financialManager.TypeFm === "SERVIDOR" && (
                  this.state.detailsData.financialManager.orgaoAverbador ? (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Órgão Averbador"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.financialManager.orgaoAverbador.orgao}
                />
              </Grid>
                  ) : (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  disabled
                  fullWidth
                  label="Órgão Averbador"
                  type="text"
                  variant="outlined"
                  size="small"
                  value="Não Encontrado"
                />
              </Grid>
                  )
                )
              }
            </Grid>
          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Corretora e Vendedor
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <TextField
                  disabled
                  fullWidth
                  label="Nome Corretora"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.salesman.broker.user.name}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <TextField
                  disabled
                  fullWidth
                  label="Nome Vendedor"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.salesman.user.name}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  disabled
                  fullWidth
                  label="Código S4E"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.salesman.codeS4}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>

      </div>
    );
  }

  responsavelFinanceiro() {

    return (
      <div>
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Informações do Responsável Financeiro
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  value={this.state.detailsData.financialManager.firstName}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'firstName')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Mãe"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="motherName"
                  value={this.state.detailsData.financialManager.motherName}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'motherName')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              {
                this.state.detailsData.financialManager.TypeFm === "SERVIDOR" ? (
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="Matrícula"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="matricula"
                  value={this.state.detailsData.financialManager.matricula}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'matricula')}
                />
              </Grid>
                ) : ('')
              }

              <Grid item xs={12} sm={12}
                md={this.state.detailsData.financialManager.TypeFm === "SERVIDOR" ? ('3'):('4')}
                lg={this.state.detailsData.financialManager.TypeFm === "SERVIDOR" ? ('3'):('4')}
              >
                <InputMask
                  mask="(99) 9999-9999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.homePhone}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'homePhone')}
                  disabled={this.state.disabledInput}
                >
                  {() => <TextField
                    fullWidth
                    label="Tel. Fixo"
                    variant="outlined"
                    size="small"
                    name="homePhone"
                    disabled={this.state.disabledInput}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12}
                md={this.state.detailsData.financialManager.TypeFm === "SERVIDOR" ? ('3'):('4')}
                lg={this.state.detailsData.financialManager.TypeFm === "SERVIDOR" ? ('3'):('4')}
              >
                <InputMask
                  mask="(99) \9 9999-9999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cellPhone}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'cellPhone')}
                  disabled={this.state.disabledInput}
                >
                  {() => <TextField
                    fullWidth
                    label="Celular"
                    variant="outlined"
                    size="small"
                    name="cellPhone"
                    disabled={this.state.disabledInput}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12}
                md={this.state.detailsData.financialManager.TypeFm === "SERVIDOR" ? ('3'):('4')}
                lg={this.state.detailsData.financialManager.TypeFm === "SERVIDOR" ? ('3'):('4')}
              >
                <InputMask
                  mask="(99) \9 9999-9999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cellPhone2}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'cellPhone2')}
                  disabled={this.state.disabledInput}
                >
                  {() => <TextField
                    fullWidth
                    label="2º Celular"
                    variant="outlined"
                    size="small"
                    name="cellPhone2"
                    disabled={this.state.disabledInput}
                  />}
                </InputMask>
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
               <TextField
                  fullWidth
                  label="Email"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="email"
                  value={this.state.detailsData.financialManager.email}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'email')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  fullWidth
                  label="RG"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="rg"
                  value={this.state.detailsData.financialManager.rg}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'rg')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  fullWidth
                  label="Org. Emissor"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="rgEmitter"
                  value={this.state.detailsData.financialManager.rgEmitter}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'rgEmitter')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="Cartão do SUS"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="susNumber"
                  value={this.state.detailsData.financialManager.susNumber}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'susNumber')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cpf}
                  disabled={true}
                >
                  {() => <TextField
                    fullWidth
                    label="CPF"
                    variant="outlined"
                    size="small"
                    name="cpf"
                    disabled={true}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Data de Nascimento"
                    format="dd/MM/yyyy"
                    size="small"
                    name="dateOfBirth"
                    value={new Date(this.state.detailsData.financialManager.dateOfBirth+'T00:00:00')}
                    disabled={this.state.disabledInput}
                    onChange={this.updateFieldDate.bind(this, 'financialManager', 'dateOfBirth')}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  id="maritalStatus"
                  fullWidth
                  select
                  label="Estado Civil"
                  variant="outlined"
                  size="small"
                  name="maritalStatus"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.maritalStatus}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'maritalStatus')}
                >
                  <option value="SOLTEIRO">Solteiro</option>
                  <option value="CASADO">Casado</option>
                  <option value="VIÚVO">Viúvo</option>
                  <option value="SEPARADO">Separado</option>
                  <option value="DIVORCIADO">Divorciado</option>
                  <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  id="gender"
                  fullWidth
                  select
                  label="Sexo"
                  variant="outlined"
                  size="small"
                  name="gender"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.gender}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'gender')}
                >
                  <option value="0">Feminino</option>
                  <option value="1">Masculino</option>
                </TextField>
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={3} lg={2}>
                <InputMask
                  mask="99.999-999"
                  maskChar=" "
                  value={this.state.detailsData.financialManager.cep}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.getAddress.bind(this)}
                >
                  {() => <TextField
                    fullWidth
                    label="CEP"
                    variant="outlined"
                    size="small"
                    name="cep"
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Logradouro"
                  variant="outlined"
                  size="small"
                  name="addressType"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.addressType}
                  disabled={true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'addressType')}
                >
                {this.state.addressTypeList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingAddressType === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }

              </Grid>
              <Grid item xs={12} sm={12} md={5} lg={7} className="containerButton">
                <TextField
                  fullWidth
                  label="Endereço"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="address"
                  value={this.state.detailsData.financialManager.address}
                  disabled={true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'address')}
                />
                {
                  this.state.disabledLoadingAddress === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={1} className="containerButton">
                <TextField
                  id="fm_addressNumber"
                  fullWidth
                  label="Nº"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="addressNumber"
                  value={this.state.detailsData.financialManager.addressNumber}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'addressNumber')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                <TextField
                  fullWidth
                  label="Complemento"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="addressComplement"
                  value={this.state.detailsData.financialManager.addressComplement}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'addressComplement')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={1} lg={1} className="containerButton">
                <TextField
                  fullWidth
                  select
                  label="UF"
                  variant="outlined"
                  size="small"
                  name="state"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.financialManager.state}
                  disabled={true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'state')}
                >
                {this.state.stateList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Sigla}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingState === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Município"
                  variant="outlined"
                  size="small"
                  name="city"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.fMCity}
                  disabled={true}
                  onChange={this.updateFieldFM.bind(this)}
                  //onBlur={this.updateDBFinancialManager.bind(this, 'city')}
                >
                {this.state.cityList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingCity === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} className="containerButton">
                <TextField
                  id="addressType"
                  fullWidth
                  select
                  label="Bairro"
                  variant="outlined"
                  size="small"
                  name="district"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.fMDistrict}
                  disabled={true}
                  onChange={this.updateFieldFM.bind(this)}
                  onBlur={this.updateDBFinancialManager.bind(this, 'district')}
                >
                {this.state.districtList.map((item, index) =>
                  <option key={index} value={item.Id}>{item.Nome}</option>
                )}
                </TextField>
                {
                  this.state.disabledLoadingDistrict === true ? (
                <CircularProgress size={24} className="progressButton" />
                  ) : ('')
                }
              </Grid>
            </Grid>
          </div>
        </Paper>
      </div>
    );
  }

  beneficiarios() {
    return (
      <div>
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Titular
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  value={this.state.detailsData.holder.firstName}
                  disabled={this.state.disabledInputHolder}
                  onChange={this.updateFieldHolder.bind(this, 'firstName')}
                  onBlur={this.updateDBHolder.bind(this, 'firstName')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Mãe"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="motherName"
                  value={this.state.detailsData.holder.motherName}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldHolder.bind(this, 'motherName')}
                  onBlur={this.updateDBHolder.bind(this, 'motherName')}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <InputMask
                  mask="999.999.999-99"
                  maskChar=" "
                  value={this.state.detailsData.holder.cpf}
                  disabled={true}
                >
                  {() => <TextField
                    fullWidth
                    label="CPF"
                    variant="outlined"
                    size="small"
                    name="cpf"
                    disabled={true}
                  />}
                </InputMask>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                  <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Data de Nascimento"
                    format="dd/MM/yyyy"
                    size="small"
                    name="dateOfBirth"
                    value={new Date(this.state.detailsData.holder.dateOfBirth+'T00:00:00')}
                    disabled={this.state.disabledInput}
                    onChange={this.updateFieldDate.bind(this, 'holder', 'dateOfBirth')}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  select
                  label="Estado Civil"
                  variant="outlined"
                  size="small"
                  name="maritalStatus"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.holder.maritalStatus}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldHolder.bind(this, 'maritalStatus')}
                  onBlur={this.updateDBHolder.bind(this, 'maritalStatus')}
                >
                  <option value="null">Selecione</option>
                  <option value="SOLTEIRO">Solteiro</option>
                  <option value="CASADO">Casado</option>
                  <option value="VIÚVO">Viúvo</option>
                  <option value="SEPARADO">Separado</option>
                  <option value="DIVORCIADO">Divorciado</option>
                  <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  id="gender"
                  fullWidth
                  select
                  label="Sexo"
                  variant="outlined"
                  size="small"
                  name="gender"
                  SelectProps={{
                    native: true,
                  }}
                  value={this.state.detailsData.holder.gender}
                  disabled={this.state.disabledInput}
                  onChange={this.updateFieldHolder.bind(this, 'gender')}
                  onBlur={this.updateDBHolder.bind(this, 'gender')}
                >
                  <option value="null">Selecione</option>
                  <option value="0">Feminino</option>
                  <option value="1">Masculino</option>
                </TextField>
              </Grid>
            </Grid>

            <Grid container spacing={2} style={{marginTop: 10}}>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="Cartão do SUS"
                  type="text"
                  variant="outlined"
                  size="small"
                  name="susNumber"
                  value={this.state.detailsData.holder.susNumber}
                  disabled={this.state.disabledInputHolder}
                  onChange={this.updateFieldHolder.bind(this, 'susNumber')}
                  onBlur={this.updateDBHolder.bind(this, 'susNumber')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <CurrencyTextField
                  label="Valor"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.holder.valuePlan.replace(',', '.')}
                  name="valuePlan"
                  currencySymbol="R$"
                  outputFormat="string"
                  decimalCharacter=","
                  digitGroupSeparator="."
                  disabled={this.state.disabledInputValuePlan}
                  onChange={this.updateCurrencydHolder.bind(this)}
                  onBlur={this.updateDBHolder.bind(this, 'valuePlan', null)}
                />
              </Grid>
            </Grid>
          </div>
        </Paper>

        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Dependentes
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
          {
            this.state.detailsData.dependents.length === 0 ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <MuiAlert severity="info" variant="filled" elevation={0}>
                  Sem dependentes cadastrados
                </MuiAlert>
              </Grid>
            </Grid>
            ) : (
              this.state.detailsData.dependents.map((item, index) =>
              <Grid container spacing={2} style={{marginTop: 10}} key={index}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="Nome Completo"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="firstName"
                    value={item.firstName}
                    disabled={this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'firstName', index)}
                    onBlur={this.updateDBDependent.bind(this, 'firstName', index)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <InputMask
                    mask="999.999.999-99"
                    maskChar=" "
                    value={item.cpf}
                    disabled={true}
                  >
                    {() => <TextField
                      fullWidth
                      label="CPF"
                      variant="outlined"
                      size="small"
                      name="cpf"
                      disabled={true}
                    />}
                  </InputMask>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}>
                    <KeyboardDatePicker
                      autoOk
                      variant="inline"
                      inputVariant="outlined"
                      label="Data de Nascimento"
                      format="dd/MM/yyyy"
                      size="small"
                      name="dateOfBirth"
                      value={new Date(item.dateOfBirth+'T00:00:00')}
                      disabled={this.state.disabledInput}
                      onChange={this.updatedDependentsDate.bind(this, index, 'dateOfBirth')}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="Mãe"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="motherName"
                    value={item.motherName}
                    disabled={this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'motherName', index)}
                    onBlur={this.updateDBDependent.bind(this, 'motherName', index)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <TextField
                    fullWidth
                    select
                    label="Grau de Perentesco"
                    variant="outlined"
                    size="small"
                    name="parentage"
                    SelectProps={{
                      native: true,
                    }}
                    value={item.parentage}
                    disabled={this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'parentage', index)}
                    onBlur={this.updateDBDependent.bind(this, 'parentage', index)}
                  >
                    <option value="CÔNJUGE">Cônjuge</option>
                    <option value="FILHO">Filho</option>
                    <option value="PAI/MÃE">Pai/Mãe</option>
                    <option value="ENTEADO">Enteado</option>
                    <option value="OUTRO">Outro</option>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <TextField
                    id="gender"
                    fullWidth
                    select
                    label="Sexo"
                    variant="outlined"
                    size="small"
                    name="gender"
                    SelectProps={{
                      native: true,
                    }}
                    value={item.gender}
                    disabled={this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'gender', index)}
                    onBlur={this.updateDBDependent.bind(this, 'gender', index)}
                  >
                    <option value="0">Feminino</option>
                    <option value="1">Masculino</option>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  <TextField
                    fullWidth
                    select
                    label="Estado Civil"
                    variant="outlined"
                    size="small"
                    name="maritalStatus"
                    SelectProps={{
                      native: true,
                    }}
                    value={item.maritalStatus}
                    disabled={this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'maritalStatus', index)}
                    onBlur={this.updateDBDependent.bind(this, 'maritalStatus', index)}
                  >
                    <option value="SOLTEIRO">Solteiro</option>
                    <option value="CASADO">Casado</option>
                    <option value="VIÚVO">Viúvo</option>
                    <option value="SEPARADO">Separado</option>
                    <option value="DIVORCIADO">Divorciado</option>
                    <option value="RELAÇÃO ESTÁVEL">Relação Estável</option>
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <TextField
                    fullWidth
                    label="Cartão do SUS"
                    type="text"
                    variant="outlined"
                    size="small"
                    name="susNumber"
                    value={item.susNumber}
                    disabled={this.state.disabledInput}
                    onChange={this.updateFieldDependent.bind(this, 'susNumber', index)}
                    onBlur={this.updateDBDependent.bind(this, 'susNumber', index)}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <CurrencyTextField
                    label="Valor"
                    variant="outlined"
                    size="small"
                    value={item.valuePlan.replace(',', '.')}
                    name="valuePlan"
                    currencySymbol="R$"
                    outputFormat="string"
                    decimalCharacter=","
                    digitGroupSeparator="."
                    disabled={this.state.disabledInputValuePlan}
                    onChange={this.updateCurrencydDependents.bind(this, index)}
                    onBlur={this.updateDBDependent.bind(this, 'valuePlan', index)}
                  />
                </Grid>

                {
                  index + 1 < this.state.detailsData.dependents.length ? (
                <div style={{width: '100%', margin: '15px 0px'}}>
                  <Divider />
                </div>
                  ) : ('')
                }
              </Grid>
              )
            )
          }


          </div>
        </Paper>
      </div>
    );
  }

  documentos() {

    return (
      <div>
        <div className="paper">
          <Grid container spacing={2}>
{/* ################### Imagem RG ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="RG Frente"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg, 'Arquivo do RG')}
                >
                  {
                    this.state.detailsData.imagesDoc.rg.length > 0 ? (
                      this.state.detailsData.imagesDoc.rg.substr(this.state.detailsData.imagesDoc.rg.length - 3, this.state.detailsData.imagesDoc.rg.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="RG Frente"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.rg}
                    title="RG Frente"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.rg.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg, 'Arquivo do RG')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem RG (verso) ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="RG Verso"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg2, 'Arquivo do Verso do RG')}
                >
                  {
                    this.state.detailsData.imagesDoc.rg2.length > 0 ? (
                      this.state.detailsData.imagesDoc.rg2.substr(this.state.detailsData.imagesDoc.rg2.length - 3, this.state.detailsData.imagesDoc.rg2.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="RG Verso"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.rg2}
                    title="RG Verso"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.rg2.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.rg2, 'Arquivo do Verso do RG')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'rg2')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem CPF ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="CPF"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.cpf, 'Arquivo do CPF')}
                >
                  {
                    this.state.detailsData.imagesDoc.cpf.length > 0 ? (
                      this.state.detailsData.imagesDoc.cpf.substr(this.state.detailsData.imagesDoc.cpf.length - 3, this.state.detailsData.imagesDoc.cpf.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="CPF"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.cpf}
                    title="CPF"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.cpf.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.cpf, 'Arquivo do CPF')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                   <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'cpf')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem Comp. de  Residência ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="Comprovante de Residência"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.resid, 'Arquivo do Comp. de  Residência')}
                >
                  {
                    this.state.detailsData.imagesDoc.resid.length > 0 ? (
                      this.state.detailsData.imagesDoc.resid.substr(this.state.detailsData.imagesDoc.resid.length - 3, this.state.detailsData.imagesDoc.resid.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Comprovante de Residência"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.resid}
                    title="Comprovante de Residência"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.resid.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.resid, 'Arquivo do Comp. de  Residência')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'resid')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'resid')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
{/* ################### Imagem Outro ################### */}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader
                  title="Outro"
                />

                <Divider style={{marginBottom: 10}}/>

                <CardActionArea
                  onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.others, 'Arquivo Outro')}
                >
                  {
                    this.state.detailsData.imagesDoc.others.length > 0 ? (
                      this.state.detailsData.imagesDoc.others.substr(this.state.detailsData.imagesDoc.others.length - 3, this.state.detailsData.imagesDoc.others.length).toLowerCase() === 'pdf' ? (
                  <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                    <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                  </div>
                      ) : (
                  <CardMedia
                    component="img"
                    alt="Outro"
                    height="140"
                    image={configBase.api + 'attachments/docs/download/' + this.state.detailsData.imagesDoc.others}
                    title="Outro"
                  />
                      )
                    ) : (
                  <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                    <MuiAlert severity="info" variant="filled" elevation={0} style={{width: '90%', margin: '0 auto'}}>
                      Documento não enviado
                    </MuiAlert>
                  </div>
                    )
                  }

                  <Divider style={{marginTop: 10, marginBottom: 10}}/>
                </CardActionArea>

                {
                  this.state.detailsData.imagesDoc.others.length > 0 ? (
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    onClick={this.openWindow.bind(this, this.state.detailsData.imagesDoc.others, 'Arquivo Outro')}
                  >
                    Visualizar
                  </Button>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                  >
                    Editar
                  </Button>
                </CardActions>
                    ) : (
                <CardActions>
                  <Button
                    size="small" color="primary"
                    onClick={this.dropzoneDialogOpen.bind(this, 'others')}
                  >
                    Enviar
                  </Button>
                </CardActions>
                    )
                  }

              </Card>
            </Grid>
          </Grid>
        </div>


        <DropzoneDialog
          dialogTitle="Upload do arquivo"
          cancelButtonText="CANCELAR"
          submitButtonText="OK"
          getFileAddedMessage={(fileName) => `Arquivo ${fileName} adicionado com sucesso.`}
          open={this.state.dropzoneDialog}
          onSave={this.fileToBase64.bind(this)}
          acceptedFiles={['image/jpeg', 'image/png', 'image/bmp', 'application/pdf']}
          showPreviews={true}
          maxFileSize={5000000}
          onClose={this.dropzoneDialogClose.bind(this)}
          filesLimit={1}
          dropzoneText="Clique ou arraste e solte um arquivo aqui"
          previewText="Pré-visualização"
          showAlerts={false}
        />
      </div>
    );
  }
  

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="resumoProposta" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  RESUMO DA PROPOSTA{this.state.titlePage}
                </Typography>
              </Grid>

              {
                this.state.showButtons === true ? (
              <Grid item xs={12} sm={12} md={12} lg={8} className="barraBotao">
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria, marginRight: 5}}
                    startIcon={<MailOutlineIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'Deseja reenviar e-mail de confirmação para o Responsável Financeiro?', 'email', 'SIM')}
                    disabled={this.state.disableButtons}
                  >
                    REENVIAR E-MAIL
                  </Button>
                </div>

                {
                  this.state.showButtonWhatsapp === true && (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: '#00bfa5', color: '#ffffff', marginRight: 5}}
                    startIcon={<WhatsAppIcon />}
                    size="small"
                  >
                    <a
                      style={{color:"#ffffff"}}
                      href={`whatsapp://send?text=Clique no link abaixo para confirmar a contratação do seu plano odontológico.`+
                        `%0a%0a*Link*: ` + configBase.front + `areacliente`+
                        `%0a*E-mail*: ` + this.state.detailsData.financialManager.email +
                        `%0a*Senha Temporária*: ` + this.state.detailsData.financialManager.password
                      }
                    >
                      CONFIRMAÇÃO POR WHATSAPP
                    </a>
                  </Button>
                </div>
                  )
                }

                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: "#dc004e", color: "#fff"}}
                    startIcon={<DeleteIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'A proposta será excluída permanentemente. Deseja continuar?', 'delete', 'SIM')}
                    disabled={this.state.disableButtons}
                  >
                    EXCLUIR PROPOSTA
                  </Button>
                </div>
              </Grid>
                ) : ('')
              }

            </Grid>

          </Paper>

          <div id="resumoPropostaConteudo" className="contentepanel">
          {
          this.state.detailsData === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  {this.state.detailsDataLoadingMsg}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.detailsData === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Problema ao buscar dados da proposta</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.detailsData === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Esta proposta não foi encontrada</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
            <div id="resumoPropostaForm">
              <ScrollableTabsButtonAuto contentTabs={
                [
                  this.detalhes(),
                  this.responsavelFinanceiro(),
                  this.beneficiarios(),
                  this.documentos()
                ]
              } />
            </div>
              )
              )
            )
          }
          </div>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.snackbarSuccess} autoHideDuration={5000} onClose={this.snackbarSuccessClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.snackbarSuccessClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSnackbarSuccess}
            </MuiAlert>
          </Snackbar>
        </div>

        <Dialog
          fullScreen={this.state.fullScreenModal}
          open={this.state.modalConfirmOpen}
          onClose={this.handleConfirmClose.bind(this)}
          aria-labelledby="i_modalConfirm"
        >
          <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {this.state.modalConfirmQuestionContent}
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <Button autoFocus color="primary"
              onClick={this.handleConfirmClose.bind(this)}
            >
              FECHAR
            </Button>

            {
              this.state.modalConfirmActionType === 'email' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.sendEmail.bind(this)}
              >
                {this.state.modalConfirmButton}
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
              ) : (
                this.state.modalConfirmActionType === 'delete' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.deleteProposal.bind(this)}
              >
                {this.state.modalConfirmButton}
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                ) : ('')
              )
            }

          </DialogActions>
        </Dialog>
      </MainLayout>
    );

  }

}

ResumoSimples.propTypes = {
  history: PropTypes.object
};

export default withRouter(ResumoSimples);